import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BreakdownsService } from 'src/app/services/http/breakdowns/breakdowns.service';
import {MatPaginator} from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { UtilsService } from 'src/app/services/tools/utils.service';
import {MatSort, Sort} from '@angular/material/sort';

@Component({
  selector: 'app-breakdown-list',
  templateUrl: './breakdown-list.component.html',
  styleUrls: ['./breakdown-list.component.scss']
})
export class BreakdownListComponent implements OnInit {

  public breakdownList: any= [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: BreakdownsService, private builder: FormBuilder, private cdr: ChangeDetectorRef, private utils: UtilsService) { }

  /**
   * Boolean indicating if spinner has to be shown while something is being loaded
   */
  public isLoading: boolean = false;

  public groupMode: number = 0;

  showData: boolean = false;

  breakdownListForm!: FormGroup;

  //displayedColumns: string[] = ['datepanne','numeroserie','codepanne','panne'];
  //displayedColumns: string[] = ['datepanne','numeroserie','codepanne','panne'];
  displayedColumns: string[] = ['numeroserie','codepanne','panne'];

  groupBreakdown: string = "0";

  ngOnInit(): void {
    this.breakdownListForm = this.builder.group({
      startBreakdownDate: ['', Validators.required],
      endBreakdownDate: ['', Validators.required],
      serialNumber: [''],
      subjectBreakdown: [''],
      breakdownCode: [''],
      groupBreakdown: [''],
      beginServiceDate: [''],
      endServiceDate: ['']
    }
    );
  }

  get displayedColumnBreakdown(): string[] {
    switch (this.groupMode) {
      case 1 :
        return ['numeroserie','departement','panne','total'];

      case 2 :
        return ['panne','total'];

      case 3 :
        return ['numeroserie','departement','total'];

      default :
        return ['datepanne','numeroserie','departement','codepanne','panne'];
    }
  }

  isColumnDisplay(columnName: string): boolean {
    return (this.displayedColumnBreakdown.indexOf(columnName) > -1);
  }

  public getNiceDate(date: string) {
    if (this.utils.getNiceDate(date) == '01/01/1970') {
      return "-";
    }

    return this.utils.getNiceDate(date);
  }

  public getData(): any[] {

    var newAr = JSON.parse(JSON.stringify(this.breakdownList.data));
    //newAr.unshift({ code: 'Au : ' + this.getNiceDate(this.endCP), nb: 0 });
    //newAr.unshift({ code: 'Du : ' + this.getNiceDate(this.startCP), nb: 0 });

    return newAr;
  }

  public onSubmitBreakdownList() {
    if (!this.breakdownListForm.valid) {
      return;
    }

    this.isLoading = true;
    this.showData = false;

    let startDate = this.breakdownListForm.controls.startBreakdownDate.value;
    let endDate = this.breakdownListForm.controls.endBreakdownDate.value;
    let serialNumber = this.breakdownListForm.controls.serialNumber.value;
    let subject = this.breakdownListForm.controls.subjectBreakdown.value;
    let code = this.breakdownListForm.controls.breakdownCode.value;
    let groupMode = this.breakdownListForm.controls.groupBreakdown.value;

    this.groupMode = this.breakdownListForm.controls.groupBreakdown.value;
    let beginServiceDate = this.breakdownListForm.controls.beginServiceDate.value;
    let endServiceDate = this.breakdownListForm.controls.endServiceDate.value;

    this.service.getAdpsBreakdownList(startDate, endDate, serialNumber, subject, groupMode, beginServiceDate, endServiceDate,code).subscribe((data) => {
      this.showData = true;

      this.breakdownList = new MatTableDataSource<Element>(data);
      this.cdr.detectChanges();

      this.breakdownList.paginator = this.paginator;
      this.breakdownList.paginator._intl.itemsPerPageLabel = 'Eléments par page : ';
      this.breakdownList.paginator._intl.firstPageLabel    = 'Première page';
      this.breakdownList.paginator._intl.previousPageLabel = 'Page précédente';
      this.breakdownList.paginator._intl.nextPageLabel     = 'Page suivante';
      this.breakdownList.paginator._intl.lastPageLabel     = 'Dernière page';

      this.breakdownList.sort = this.sort;

      this.isLoading = false;
    });

  }

}
